var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegistration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#112d55",
    d: "M15.14 21.75H5.86c-1.439 0-2.61-1.233-2.61-2.75V5c0-1.517 1.171-2.75 2.61-2.75h9.28c1.439 0 2.61 1.233 2.61 2.75v4a.75.75 0 0 1-1.5 0V5c0-.678-.508-1.25-1.11-1.25H5.86c-.602 0-1.11.572-1.11 1.25v14c0 .678.508 1.25 1.11 1.25h9.28c.602 0 1.11-.572 1.11-1.25v-4a.75.75 0 0 1 1.5 0v4c0 1.517-1.171 2.75-2.61 2.75zM14.75 7a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 .75-.75zm-2 3a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 .75-.75z",
    opacity: 1,
    "data-original": "#112d55",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M11.687 18.562a1.248 1.248 0 0 1-1.225-1.494l.441-2.207a2.735 2.735 0 0 1 .752-1.406l5.935-5.936c1.072-1.071 2.817-1.072 3.889 0s1.072 2.817 0 3.889l-5.936 5.936a2.728 2.728 0 0 1-1.405.752l-2.207.441a1.207 1.207 0 0 1-.246.024zm7.849-10.348c-.32 0-.64.122-.884.366l-5.936 5.936a1.25 1.25 0 0 0-.342.638l-.368 1.839 1.839-.368c.242-.048.463-.167.638-.342l5.936-5.936a1.252 1.252 0 0 0-.884-2.134z",
    opacity: 1,
    "data-original": "#549bff",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.bc5660adeb352858ad3037974f028c32.svg";
export { ForwardRef as ReactComponent };